import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'

import { Page } from '../../components'
import { CustomerDetailsContainer } from '../../components/CustomerDetail/CustomerDetailsContainer'
import { AuthContext } from '../../providers'
import { useGetCustomerDetailQuery } from '../../redux/api'
import { loggingAssert } from '../../utils/handleError/loggingAssert'

export default function CustomerDetails() {
  const { id: customerId } = useParams()
  const { currentUser, userShopId } = useContext(AuthContext)
  const shopId = loggingAssert('ShopId not set', userShopId)
  const accessToken = loggingAssert('Token not set', currentUser!.accessToken)
  const {
    data: customers,
    error,
    isLoading
  } = useGetCustomerDetailQuery({
    authorization: accessToken,
    shop: shopId,
    customer: [customerId!]
  })
  return (
    <Page title={'Customer Detail'} isLoading={isLoading} error={!!error}>
      {customers && customers[0] && (
        <CustomerDetailsContainer customer={customers[0]} />
      )}
    </Page>
  )
}
